import styled from 'styled-components'
import { Switch } from 'antd'
import { Text } from '@lmc/ui-kit/src/general'
import colors from '@lmc/common/constants'

type LogsSeizureDeEscalationProps = {
  deEscalated: boolean
  onChange: (deEscalated: boolean) => void
}

const LogsSeizureDeEscalation = ({
  deEscalated,
  onChange,
}: LogsSeizureDeEscalationProps) => {
  const label = deEscalated ? 'De-escalated' : 'De-escalate to Health Recording'
  const color = deEscalated ? colors.purple : colors.red

  return (
    <Wrapper>
      <LeftContainer>
        <CategoryColor color={color} />
        <DeEscalationLabel level={2}>{label}</DeEscalationLabel>
      </LeftContainer>
      <Switch value={deEscalated} onChange={onChange} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 400px;
  margin: 0px auto;
  margin-bottom: 15px;
  display: flex;
  flex: 1;
  align-items: center;
  border: solid;
  border-width: 1px;
  border-color: ${colors.grey};
  padding: 4px 8px;
  background-color: ${colors.white};
  border-radius: 4px;
`

const LeftContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 4px;
`
const DeEscalationLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-size: 14px;
`
const CategoryColor = styled.div<{ color: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  margin: 8px;
`

export default LogsSeizureDeEscalation
